import { Typography } from "@mui/material";
import { BasicTableRowStyles } from "../../../components/common/Common.styles";
import BorderRow from "../../../components/common/table/BorderRow";
import CellBox from "../../../components/common/table/CellBox";
import { AnalysisFile } from "../../../types/analysisFileTypes";
import DownloadBtn from "../../../components/common/table/DownloadBtn";
import dayjs from "dayjs";
import { t } from "i18next";


interface Props {
  row: AnalysisFile;
  showCompanyName: boolean;
}

export default function AnalysisFileTableRow(props: Props) {
  return (
    <BasicTableRowStyles>
      {
        props.showCompanyName &&
        <CellBox firstCol>
          <Typography>{props.row.companyName}</Typography>
        </CellBox>
      }
      <CellBox firstCol={!props.showCompanyName}>
        <Typography>{dayjs(props.row.creationTimestamp).format("DD.MM.YYYY")}</Typography>
      </CellBox>
      <CellBox>
        <Typography>{t(`analysisFileType.${props.row.fileType}`)}</Typography>
      </CellBox>
      <CellBox>
        <DownloadBtn downloadUrl={props.row.downloadUrl} />
      </CellBox>
      <BorderRow />
    </BasicTableRowStyles>
  );
};
